// Stacking order for chrome that interleaves on the desktop shell
// (sidebar, docked panel, dialogs, dropdowns). Map overlays sit lowest;
// dialogs always win. New absolutely-positioned chrome must take its
// zIndex from here, not a literal.
export const Z_INDEX = {
  mapOverlay: 10,
  tabBar: 50,
  sidebar: 60,
  dockedPanel: 70,
  dropdown: 100,
  // Short menus/previews anchored to a trigger (Popover.web.tsx: the create
  // menu, ContentActionMenu on the desktop shell): above every docked panel,
  // below every modal and toast.
  popover: 150,
  dialog: 1000,
  // Above dialogs: a toast fired from inside a dialog (Ask for an update)
  // must not land under its scrim. Below the fullscreen slideshow.
  toast: 1050,
  // Fullscreen observation presentation (MapSlideshow.web.tsx) — a
  // presentation surface, not a sheet, so it sits above every dialog.
  slideshow: 1100,
} as const;
